import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
export function PainSection() {
  const painPoints = ['Dormís mal. Te despertás con calor y cansancio.', 'Tu cuerpo cambió sin avisar. Comés igual y te inflamás / subís fácil.', 'Niebla mental. Te cuesta concentrarte y te olvidás de cosas simples.', 'Energía baja. Todo te agota y a la tarde te caés.'];
  return <section className="bg-gradient-section py-12 md:py-16 px-4 md:px-8" data-id="element-171">
      <div className="max-w-3xl mx-auto space-y-14" data-id="element-172">
        {/* Eyebrow title */}
        <motion.p initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center uppercase tracking-[0.3em] text-[#C8A870] font-semibold text-[13px]" data-id="element-173">
          Una historia que podría ser la tuya
        </motion.p>

        {/* Story Block */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="card-premium p-7 md:p-12 relative overflow-hidden" data-id="element-174">
          <div className="absolute left-0 top-0 bottom-0 w-[2px] bg-gradient-to-b from-transparent via-gold/60 to-transparent" data-id="element-175" />

          <div className="space-y-6 pl-3 md:pl-6" data-id="element-176">
            <p className="italic text-[19px] md:text-[22px] text-foreground/80 font-body leading-[1.7]" data-id="element-177">
              María Elena tenía 43 años. Comía bien, caminaba, dormía temprano.
            </p>

            <p className="italic text-[19px] md:text-[22px] text-foreground/80 font-body leading-[1.7]" data-id="element-178">
              Y aun así su cintura cambió. Se despertaba agotada. Se sentía
              inflamada todo el día.
            </p>

            <p className="font-semibold italic text-[20px] md:text-[24px] text-[#F0E8D8] font-body leading-[1.55] pt-1" data-id="element-179">
              "Pensé que era falta de disciplina… hasta que entendí que mi
              cuerpo estaba en una transición real."
            </p>

            <div className="divider-fine w-full !mt-8" data-id="element-180" />

            <p className="md:text-[16px] text-foreground/55 font-body pt-2 text-[16px]" data-id="element-181">
              No era su voluntad. Era su bioquímica. Cuando entendió lo que
              pasaba, dejó de culparse y{' '}
              <span className="text-[#C8A870] font-semibold" data-id="element-182">
                empezó con una estrategia distinta.
              </span>
            </p>
          </div>
        </motion.div>

        {/* Pain Points */}

        {/* Closing */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center pt-4" data-id="element-183">
          <p className="font-display italic md:text-[28px] max-w-xl mx-auto text-[#C8A870] text-[23px]" data-id="element-184">
            "Cuando entendés lo que le pasa a tu cuerpo, dejás de pelearte con
            él."
          </p>
        </motion.div>
      </div>
    </section>;
}